// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RRg9x{max-width:1077px}.tioU3{opacity:0;pointer-events:none;transition:opacity .35s}.DffU4{opacity:1}.ErNEv{background-color:#fff}.HSOWc{width:50px}.uDSFM{width:60px;height:60px}`, "",{"version":3,"sources":["webpack://./src/components/stepSection/scheme/Scheme.module.scss"],"names":[],"mappings":"AAAA,OACE,gBAAA,CAGF,OACE,SAAA,CACA,mBAAA,CACA,uBAAA,CAGF,OACE,SAAA,CAGF,OACE,qBAAA,CAGF,OACE,UAAA,CAGF,OACE,UAAA,CACA,WAAA","sourcesContent":[".root {\n  max-width: 1077px;\n}\n\n.hidden {\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.35s;\n}\n\n.visible {\n  opacity: 1;\n}\n\n.iconBg {\n  background-color: #ffffff;\n}\n\n.icon {\n  width: 50px;\n}\n\n.noteIconContainer {\n  width: 60px;\n  height: 60px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `RRg9x`,
	"hidden": `tioU3`,
	"visible": `DffU4`,
	"iconBg": `ErNEv`,
	"icon": `HSOWc`,
	"noteIconContainer": `uDSFM`
};
export default ___CSS_LOADER_EXPORT___;
